import request from '@/utils/httpRequest'

export default class deliveryService {
    queryById(id) {
        return request({
            url: '/retrieval/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }
}
